import UserCard from "../custom-components/UserComponents/UserCard";
import UserTable from "../custom-components/UserComponents/UserTable";
import React, {useEffect, useState} from "react";
import {User} from "../../types/userTypes";
import {changePassword, updateUser} from "../../queries/userQueries";
import OrganizationTable from "../custom-components/UserComponents/OrganizationTable";
import Box from "@mui/material/Box";
import {APP_PERMISSION, EntityType} from "../../constants/userConstants";
import useAuth from "../../hooks/useAuth";
import {enqueueSnackbar} from "notistack";
import RoleDataGrid from "@/pages/custom-components/UserComponents/RoleDataGrid";
import PermissionRendering from "@/pages/custom-components/UserComponents/PermissionRendering";

export default function UserPage(){

    const auth = useAuth()


    const [updatedEntity, setUpdatedEntity] = useState<EntityType.users | EntityType.organizations | "">("")


    const handeChangeUser = (user: User, userId: string) => {
        updateUser(user, userId).then(response => {
            enqueueSnackbar("Information Changed")
            auth.updateLocalStorageUser(user)
        })
    }

    const handleChangePassword = (userId: string) => {
        changePassword(userId).then(response => {
            enqueueSnackbar("An email has been sent to change your password")
        })
    }

    const handleUpdateEntity = (value: EntityType.users | EntityType.organizations | "") => {
        setUpdatedEntity(value)
    }

    useEffect(() => {
    },[updatedEntity])

    return(
            <Box style={{
                width: "100%",
                height: "100%",
                overflowY: "auto",
            }}>
                <UserCard changeUserInformation={handeChangeUser} changePassword={handleChangePassword}/>
                <PermissionRendering permissions={[APP_PERMISSION.GET_ORGANIZATION, APP_PERMISSION.GET_USER]}><UserTable updateEntity={updatedEntity} handleUpdateEntity={handleUpdateEntity}/></PermissionRendering>
                <PermissionRendering permissions={[APP_PERMISSION.GET_ORGANIZATION]}><OrganizationTable updateEntity={updatedEntity} handleUpdateEntity={handleUpdateEntity}/></PermissionRendering>
                <PermissionRendering permissions={[APP_PERMISSION.GET_ROLE]}><RoleDataGrid/></PermissionRendering>
            </Box>
    )
}